<template>
  <div class="browser-support">
    <p>因相容性問題與安全因素，本網站不支援微軟 IE 瀏覽器。請使用 <a href="https://www.google.com/intl/zh-TW_ALL/chrome/" target="_blank">Google Chrome</a>、<a href="https://www.mozilla.org/zh-TW/firefox/new/" target="_blank">Mozilla Firefox</a>、<a href="https://www.microsoft.com/zh-tw/windows/microsoft-edge" target="_blank">Microsoft Edge</a> 等現代瀏覽器進行瀏覽。</p>
  </div>
</template>

<script>
export default {
  methods: {
    getIEVersion () {
      let sAgent = window.navigator.userAgent
      let Idx = sAgent.indexOf("MSIE")

      if (Idx > 0) {
        // If IE, return version number.
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)))
        // eslint-disable-next-line
      } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
        // If IE 11 then look for Updated user agent string.
        return 11
      } else {
        // It is not IE
        return 0
      }
    }
  },
  mounted () {
    let ieVersion = this.getIEVersion()

    if (ieVersion > 0) {
      console.log('IE ' + ieVersion)
    }
  }
}
</script>
